module.exports = __webpack_public_path__ + "static/media/oneshelf-pic9.e7dde711.JPG";